import React, { useState, useCallback, useEffect, } from "react";
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../reducers/actions/auth";
import '../../assets/sidebar.css';
import { useNavigate } from "react-router-dom";

const Sidebar = (props) => {

  const {user: currentUser} = useSelector((state) => state.auth)
  const userRoles = currentUser.roles
  const isSuperAdmin = userRoles?.includes('SuperAdmin'); 
  const isApprover = userRoles?.includes('Approver'); 
  const isSecondApprover = userRoles?.includes('SecondApprover'); 
  const isClient = userRoles?.includes('Client'); 
  
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = useCallback(() => {
    dispatch(logout());
    return navigate("/login")
  }, [dispatch]);

  return (
    <>
      <div
        className={` ${
          props.isOpen
            ? "side-navbar d-flex justify-content-between flex-wrap flex-column active-nav"
            : "side-navbar d-flex justify-content-between flex-wrap flex-column"
        }`}
        id="sidebar"
      >
        <ul className="nav flex-column text-white w-100">
          <a
            href="#"
            className="nav-link-header h3 text-white my-2 text-decoration-none"
          >
            Visitantes
          </a>
          {isClient && (
            <>
              <NavLink to="/instructive" className={"nav-link li"}>
                <i className="bi bi-house-fill"></i> Home
              </NavLink>
              <NavLink to="/request/new" className={"nav-link li"}>
                <i className="bi bi-file-earmark-plus-fill"></i> Nueva solicitud
              </NavLink>
              <NavLink to="/request/all" className={"nav-link li"}>
                <i className="bi bi-card-list"></i> Mis solicitudes
              </NavLink>
              <NavLink to="/request/personal" className={"nav-link li"}>
                <i className="bi bi-person-rolodex"></i> Mi Personal
              </NavLink>
              <NavLink to="/request/vehicles" className={"nav-link li"}>
                <i className="bi bi-car-front-fill"></i> Mis Vehiculos
              </NavLink>
            </>
          )}
          {(isSuperAdmin || isSecondApprover) && (
            <>
              <NavLink to="/instructive" className={"nav-link li"}>
                <i className="bi bi-house-fill"></i> Home
              </NavLink>
              <NavLink to="/request/new" className={"nav-link li"}>
                <i className="bi bi-file-earmark-plus-fill"></i> Nueva solicitud
              </NavLink>
              <NavLink to="/request/all" className={"nav-link li"}>
                <i className="bi bi-card-list"></i> Mis solicitudes
              </NavLink>
              <NavLink to="/request/personal" className={"nav-link li"}>
                <i className="bi bi-person-rolodex"></i> Mi Personal
              </NavLink>
              <NavLink to="/request/vehicles" className={"nav-link li"}>
                <i className="bi bi-car-front-fill"></i> Mis Vehiculos
              </NavLink>
              <NavLink to="/request/approve" className={"nav-link li"}>
                <i className="bi bi-door-open"></i> Aprobar solicitudes
              </NavLink>
            </>
          )}
          {isApprover && (
            <>
              <NavLink to="/instructive" className={"nav-link li"}>
                <i className="bi bi-house-fill"></i> Home
              </NavLink>
              <NavLink to="/request/approve" className={"nav-link li"}>
                <i className="bi bi-door-open"></i> Aprobar solicitudes
              </NavLink>
            </>
          )}
        </ul>

        <div className="py-sm-1 m-3 logout">
          <span href="#" className="nav-link h4 w-100">
            <i className="bi bi-person-bounding-box"> {currentUser.name}</i>
          </span>
          <a onClick={logOut} className={"nav-link li logout"}>
            <i className="bi bi-box-arrow-left"></i> LogOut
          </a>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
